var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "40.5188mm",
    height: "10.6178mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 4037.67 1058.06",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993224696880"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#2B2A29",
    cx: 249.32,
    cy: 529.03,
    r: 249.32
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2B2A29",
    x: 209.96,
    y: 492.57,
    width: 3827.73,
    height: 72.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A29",
    d: "M4037.67 492.57l-492.58 -492.57 -51.56 51.56 492.57 492.58 51.57 -51.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A29",
    d: "M4037.67 565.49l-492.58 492.57 -51.56 -51.56 492.57 -492.58 51.57 51.57z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.b14da59407be3be00bfdc6a7f8e65d41.svg";
export { ForwardRef as ReactComponent };